import * as React from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@axilon-apps/libs-ui-shadcn'

interface Props {
  perPage: number
  options: Array<number>
  disabled?: boolean
  onChange: (itemsPerPage: number) => void
  hidden?: boolean
  label?: string
}

const PaginationPerPage = ({ disabled, onChange, perPage, options, hidden, label }: Props) => {
  const [items, setItems] = React.useState<number>(perPage)

  if (hidden) {
    return null
  }

  const handleChange = (value: string) => {
    const next = Number(value)
    setItems(next)
    onChange(next)
  }

  return (
    <div className="flex items-center gap-2">
      {label && <span className="text-sm">{label}</span>}
      <Select disabled={disabled} value={String(items)} onValueChange={handleChange}>
        <SelectTrigger size="sm" className="min-w-[64px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option} value={String(option)}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export default PaginationPerPage
